:host {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 200px;
  position: relative;
}

:host.sellalong-panel-purchase-item-sample {
  opacity: 0.15;
}

:host > a {
  color: #000;
  text-decoration: none;
}

:host > .sellalong-panel-purchase-item-figure-wrapper {
  flex: 1;
}

:host figure {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  padding: 0;
}

.sellalong-panel-purchase-item-image {
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  height: 150px;
  outline: 3px solid transparent;
  outline-offset: -3px;
  transition: outline-color 0.5s;
  width: 200px;
}

/** Sample item text overlay */
:host(.sellalong-panel-purchase-item-sample)::before {
  content: "Sample";
  position: absolute;
  background: transparent;
  color: #fff;
  display: block;
  font-family: var(--sellalong-label-font, sans-serif);
  font-size: 32px;
  font-weight: bold;
  height: 150px;
  left: 0;
  line-height: 150px;
  text-align: center;
  text-transform: uppercase;
  top: 0;
  transform: rotate(-45deg);
  width: 200px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0, 0, 0, 0.7);
}

.sellalong-panel-purchase-item-title {
  display: flex;
  flex-direction: column;
  flex: 1;
  font-family: var(--sellalong-heading-font, serif);
  font-size: 18px;
  font-weight: normal;
  line-height: 1.2em;
  margin: 6px 0 12px;
  text-align: center;
  text-decoration: none;
}

.sellalong-panel-purchase-item-purchase-age {
  font-family: var(--sellalong-label-font, sans-serif);
  font-size: 13px;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.sellalong-panel-purchase-item-seller {
  font-family: var(--sellalong-label-font, sans-serif);
  font-size: 12px;
  letter-spacing: 1px;
}

.sellalong-panel-purchase-item-offer {
  align-items: flex-end;
  display: flex;
  flex: 1;
  justify-content: center;
  margin-top: 15px;
}

.sellalong-panel-purchase-item-message {
  align-items: center;
  display: flex;
  font-family: var(--sellalong-label-font, sans-serif);
  font-size: 12px;
  min-height: 30px;
  text-align: center;
}

.sellalong-panel-purchase-item-select-button {
  background: #fff;
  border: solid 1px var(--sellalong-colour-secondary, #000);
  border-radius: 3px;
  color: #000;
  cursor: default;
  font-family: var(--sellalong-control-font, sans-serif);
  font-size: 10px;
  letter-spacing: 1.5px;
  line-height: 26px;
  margin: 0;
  padding: 2px 15px 0;
  text-align: center;
  text-transform: uppercase;
  transition: color 0.1s, background-color 0.1s, border-color 0.1s;
}

.sellalong-panel-purchase-item-select-cta {
  cursor: pointer;
}

:host.sellalong-panel-purchase-item-state-tosell
  .sellalong-panel-purchase-item-select-cta {
  background: var(--sellalong-colour-primary, #000);
  border-color: var(--sellalong-colour-primary, #000);
  color: #fff;
}

:host.sellalong-panel-purchase-item-state-tosell
  .sellalong-panel-purchase-item-image {
  outline-color: var(--sellalong-colour-primary, #000);
  border-radius: 3px;
}
